// =============================
// The 32 Initiative - Page Motion & Interactions
// =============================

// Scroll Reveal Animations
(function() {
  const revealEls = document.querySelectorAll('.the32-page [data-reveal]');
  if (!('IntersectionObserver' in window) || !revealEls.length) {
    revealEls.forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  revealEls.forEach((el, i) => {
    el.style.transitionDelay = `${i * 0.08}s`;
    observer.observe(el);
  });
})();

// Page Fade-In on Load
window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
});

// Hero Parallax Glow
window.addEventListener('scroll', () => {
  const hero = document.querySelector('.the32-page .hero.hero--center');
  if (!hero) return;
  const offset = window.scrollY * 0.25;
  hero.style.backgroundPosition = `center ${offset}px`;
});